<template>
  <div class="whs-detail-status">
    <div v-if="currentlyLoading" class="whs-progress" :style="{ width: progress + '%' }"></div>
    <div v-if="currentlyLoading" class="whs-loading whs-icon-left">{{ loadingMessage || wait }}</div>
    <!-- <div v-if="error" class="whs-error whs-icon-left">{{ errorMessage }}</div> -->
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Status',
  props: {
    error: Boolean,
    loading: {
      type: [String, Boolean]
    },
    loadingMessage: {
      type: [String, Boolean]
    },
    errorMessage: {
      type: String,
      default: 'Извините, не удалось найти отели.'
    },
    wait: {
      type: String,
      default: 'Подождите, идет загрузка'
    }
  },
  created: function() {
    this.progressInterval = this.showProgress();
    // console.log('start: ' + this.wait);
  },
  data: function() {
    return {
      progressInterval: null,
      progress: 0
    };
  },
  watch: {
    currentlyLoading: function(val) {
      if (val) {
        if (this.progressInterval) return;
        this.progressInterval = this.showProgress();
      } else {
        clearInterval(this.progressInterval);
        this.progress = 0;
      }
    }
  },
  computed: {
    ...mapGetters(['isLoading']),
    currentlyLoading() {
      return this.loading || (this.wait && this.isLoading(this.wait));
    }
  },
  methods: {
    showProgress() {
      const vm = this;
      let step = 0.5;
      let current_progress = 0;
      return setInterval(() => {
        current_progress += step;
        vm.progress =
          Math.round(
            (Math.atan(current_progress) / (Math.PI / 2)) * 100 * 1000
          ) / 1000;
        if (vm.progress >= 100) {
          clearInterval(vm.progressInterval);
          vm.progress = 0;
        } else if (vm.progress >= 70) {
          step = 0.1;
        }
      }, 100);
    }
  }
};
</script>

<style scoped>
.whs-detail-status {
  padding: 24px;
  width: 100%;
  position: relative;
  /* background-color: var(--color-bg); */
}
.whs-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background-color: var(--color-main);
}
.whs-error,
.whs-loading,
.whs-detail-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.whs-error:before,
.whs-loading:before {
  content: '\f82b';
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: var(--color-main);
  animation: spin 2s infinite;
}
.whs-error:before {
  content: '\f071';
  animation: none;
}
</style>